<template>
  <div>
    <FormItem
      :label="field.label || 'Область'"
      :required="required"
      data-testid="citycode__region"
    >
      <Select
        :value="value"
        filterable
        clearable
        placeholder="Выберите область"
        autocomplete="off"
        :loading="loading"
        @change="onSelect"
      >
        <Option
          v-for="(option, i) in options"
          :key="i"
          :label="option.name"
          :value="option.kladr_code"
          data-testid="citycode__region__option"
        />
        <template #help>
          {{ field.comment || '' }}
        </template>
      </Select>
    </FormItem>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Region',
  props: {
    value: {
      type: String,
      default: '',
    },
    field: {
      type: Object,
      required: true,
    },
    model: {
      type: Object,
      required: true,
    },
    required: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      options: this.regions || [],
    };
  },
  created() {
    this.setOptions(this.regions || []);
  },

  computed: {
    ...mapState({
      regions: (state) => state.utils.regions,
      foList: (state) => state.utils.help.fo,
    }),
  },

  methods: {
    resolveFO(val) {
      const region = this.regions.find((item) => item.kladr_code === val);

      const fo = region
        ? this.foList.raw.find((item) => item.value === region.fo_name)
        : null;
      if (fo) {
        return fo.id;
      }

      return null;
    },
    onSelect(val) {
      this.$emit('change', 'city', null);
      this.$emit('change', 'region', val);

      if (val) {
        const fo = this.resolveFO(val);
        this.$emit('change', 'fo', fo);
      }
    },
    setOptions(options) {
      this.options = options;
    },
    filterRegionsByFo(foId) {
      const fo = this.foList.id[foId];

      if (fo) {
        const filteredRegions = this.regions.filter(
          (item) => item.fo_name === fo
        );
        this.setOptions(filteredRegions);
      }
    },
  },
  watch: {
    regions(list) {
      // обновляем опции селекта после загрузки регионов
      this.setOptions(list);
    },
    model(updatedDict) {
      // если поменялся числовой идентификатор федерального округа, фильтируем список опций с регионами по этому ФО
      if (updatedDict.fo) {
        this.filterRegionsByFo(updatedDict.fo);
      }

      if (!updatedDict.fo) {
        // если ФО был сброшен, используем список регионов по-умолчанию
        this.setOptions(this.regions);
      }
    },
  },
};
</script>

<style lang="scss"></style>
